import type { Theme, SxProps } from '@mui/material/styles';
import type { MapRef, MapProps as ReactMapProps } from 'react-map-gl/mapbox';

import { appMapApi } from '@/store/reducerApp';
import { styled } from '@mui/material/styles';
import ReactMap from 'react-map-gl/mapbox';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

export type MapProps = ReactMapProps & {
  sx?: SxProps<Theme>;
  ref?: React.RefObject<MapRef | null>;
};

export function Map({ ref, sx, ...other }: MapProps) {
  const mapApiKey = useSelector(appMapApi);

  return (
    <MapRoot sx={sx}>
      <ReactMap ref={ref} mapboxAccessToken={mapApiKey} {...other} />
    </MapRoot>
  );
}

// ----------------------------------------------------------------------

const MapRoot = styled('div')({
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
});
